import { AdminRouter } from 'stylemix-vue-admin'

const routes = [
  {
    path: '/zones',
    name: 'zones',
    component: () => import('./page-zones'),
  },
]

AdminRouter.addRoutes(routes)
